// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"671":"4c752035","894":"d7ba3029"}[chunkId] + ".css";
};